import HealthInsurances from './HealthInsurances';

export default HealthInsurances;
